<template>
  <div class="main-nav-bar shadow">
    <b-navbar toggleable="lg" type="light" variant="light">
      <b-navbar-brand to="/">Maxico</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item to="/blogs">Blog</b-nav-item>
          <b-nav-item to="/about">About</b-nav-item>
          <b-nav-item to="/links">Links</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto" v-if="this.$route.name === 'Blogs'">
          <b-nav-form>
            <b-form-input
              size="sm"
              class="mr-sm-2 search-width"
              placeholder="Search Blogs..."
              @keyup="submitSearch()"
              @submit.prevent="submit"
              v-model="blogTitle"
            ></b-form-input>
            <!-- TODO: add validation? :state="false" ^^^ -->
          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: "MainNavBar",
  data() {
    return {
      blogTitle: null
    }
  },
  methods: {
    submitSearch() {
        this.$emit('search', this.blogTitle);
    }
  }
};
</script>

<style lang="scss">
.main-nav-bar {
  /* background-color: #00b386; */
  border: solid #000 1px;
  // https://www.geeksforgeeks.org/how-to-override-the-css-properties-of-a-class-using-another-css-class/
  // https://stackoverflow.com/questions/6323995/how-to-override-a-css-class
  @media (max-width: 768px) {
    // #nav-collapse form form-inline {
    //     display: inline-block;
    //     flex-flow: nowrap;
    //     align-items: center;
    //     width: 100%;
    // }
    #nav-collapse li.form-inline {
        display: inline-block;
        flex-flow: nowrap;
        align-items: center;
        width: 100%;
        // margin-left: 35%;
    }    
  }
}
</style>
